import { Add as AddIcon } from '@mui/icons-material';

import { FullSizeAssemblyScreenProps } from './FullSizeAssemblyScreen.interface';
import {
  FullSizeAssemblyScreenContainer,
  FullSizeAssemblyScreenEditIconContainer,
} from './FullSizeAssemblyScreen.styled';

export const FullSizeAssemblyScreen = (props: FullSizeAssemblyScreenProps) => {
  return (
    <FullSizeAssemblyScreenContainer
      width={props.width}
      height={props.height}
      $selectable={props.selectable}
      $type={props.type}
      $isSelected={props.isSelected}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      data-testid="assembly-screen"
      onClick={props.selectable ? props.onClick : undefined}>
      {props.children}

      {props.showEditIcon && props.selectable && (
        <FullSizeAssemblyScreenEditIconContainer>
          <AddIcon />
        </FullSizeAssemblyScreenEditIconContainer>
      )}
    </FullSizeAssemblyScreenContainer>
  );
};
